export const Plusnet = {
  id: "PLUSNET_ROUTER",
  img: "../../images/devices/plusnet.png",
  name: "Plusnet Hub",
  rating: 5,
  availableColors: ["black"],
  details: {
    title1: "Supports dual Wi-Fi with wireless ac​",
    text1:
      "Intelligently selects your optimal Wi-Fi band for the fastest browsing experience​",
    title2: "USB Port​",
    text2:
      "You can now plug in devices such as printers directly into your router​",
    title3: "Fibre enabled​",
    text3:
      "You can now access the fastest internet speeds available through the One Hub router​"
  }
}
